import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, Children } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, ArrowForwardSVGpath, ArrowDownSVGpath } from '@skatteetaten/ds-icons';
import { Link } from '../Link/index.esm.js';
import { LinkContext } from '../LinkContext/index.esm.js';
import 'react-i18next';
import './styles.css';


const getLinkGroupVariantDefault = ()=>'list';

var styles = {
    "linkGroup": "LinkGroup-module_linkGroup__MX9px",
    "linkGroup_hasSpacing": "LinkGroup-module_linkGroup_hasSpacing__jhdNP",
    "linkGroupItem": "LinkGroup-module_linkGroupItem__DRFFD",
    "icon": "LinkGroup-module_icon__4r8Ft",
    "icon_white": "LinkGroup-module_icon_white__DwI7x",
    "icon_forward": "LinkGroup-module_icon_forward__ST-l5",
    "icon_down": "LinkGroup-module_icon_down__vgwRw"
};

const LinkGroup = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, hasSpacing, color, variant = getLinkGroupVariantDefault(), children }, ref)=>{
    const hasVariantList = variant !== 'anchors';
    const iconPath = hasVariantList ? ArrowForwardSVGpath : ArrowDownSVGpath;
    const iconVariantClassName = hasVariantList ? `${styles.icon_forward}` : `${styles.icon_down}`;
    const concatenatedIconClassName = `${styles.icon} ${iconVariantClassName} ${color ? styles[`icon_${color}`] : ''}`.trim();
    const spacingClassName = hasSpacing ? styles.linkGroup_hasSpacing : '';
    const concatenatedClassName = `${styles.linkGroup} ${spacingClassName} ${className}`.trim();
    const links = Children.toArray(children);
    return /*#__PURE__*/ jsx("ul", {
        ref: ref,
        id: id,
        className: concatenatedClassName,
        lang: lang,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ jsx(LinkContext.Provider, {
            value: {
                color
            },
            children: links.map((child, index)=>{
                return /*#__PURE__*/ jsxs("li", {
                    className: styles.linkGroupItem,
                    children: [
                        /*#__PURE__*/ jsx(Icon, {
                            className: concatenatedIconClassName,
                            svgPath: iconPath
                        }),
                        child
                    ]
                }, index);
            })
        })
    });
});
LinkGroup.displayName = 'LinkGroup';
LinkGroup.Link = Link;

export { LinkGroup, getLinkGroupVariantDefault };
